import RenameFileDialog from './RenameFileDialog';

export default RenameFileDialog;
